import React from 'react';

import HTMLRenderer from './ContentHTMLRenderer';


export default function ContentSection({children, sectionId, bgColor, bgImg, bgOpacity, classes, pageId, contentData }) {
  console.log('Raw contentData:', JSON.stringify(contentData));

  // Safely normalize contentData
  const normalizedContent = typeof contentData === 'string' ? contentData.replace(/\\n/g, '\n') : '';
  console.log('Normalized content:', JSON.stringify(normalizedContent));

  const sectionStyle = {
    backgroundColor: bgColor || 'transparent',
    backgroundImage: bgImg ? `url(${bgImg})` : 'none',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    opacity: bgOpacity || 1,
  };



  return (
    <section id={sectionId} className={`h-full ${classes || ''}`} style={sectionStyle}>
      <HTMLRenderer html={normalizedContent} />
      {children}
    </section>
  );
}